import React, { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext(null);

export function BreadcrumbProvider({ children }) {
  const [overrideLabel, setOverrideLabel] = useState(null);
  const [overrideCity, setOverrideCityState] = useState(null);
  const [overrideLocation, setOverrideLocationState] = useState(null);
  const [isPremiumProjectPage, setIsPremiumProjectPage] = useState(false);

  const setBreadcrumbLabel = useCallback((label) => {
    setOverrideLabel(typeof label === 'string' ? label : null);
  }, []);

  const setBreadcrumbLocation = useCallback((city, location) => {
    setOverrideCityState(city != null && String(city).trim() !== '' ? String(city).trim() : null);
    setOverrideLocationState(location != null && String(location).trim() !== '' ? String(location).trim() : null);
  }, []);

  const clearBreadcrumbLocation = useCallback(() => {
    setOverrideCityState(null);
    setOverrideLocationState(null);
  }, []);

  const setPremiumProjectPage = useCallback((value) => {
    setIsPremiumProjectPage(Boolean(value));
  }, []);

  return (
    <BreadcrumbContext.Provider
      value={{
        overrideLabel,
        setBreadcrumbLabel,
        overrideCity,
        overrideLocation,
        setBreadcrumbLocation,
        clearBreadcrumbLocation,
        isPremiumProjectPage,
        setPremiumProjectPage,
      }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  const ctx = useContext(BreadcrumbContext);
  return (
    ctx || {
      overrideLabel: null,
      setBreadcrumbLabel: () => {},
      overrideCity: null,
      overrideLocation: null,
      setBreadcrumbLocation: () => {},
      clearBreadcrumbLocation: () => {},
      isPremiumProjectPage: false,
      setPremiumProjectPage: () => {},
    }
  );
}
